import { render } from "./KubernetesNetworking.vue?vue&type=template&id=34ff32de"
import script from "./KubernetesNetworking.vue?vue&type=script&lang=js"
export * from "./KubernetesNetworking.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__